import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import * as Admin from '../../../store/admin';
import * as App from '../../../store/app';

import { ManageContractorSettings } from '@components/admin/contractors/ManageContractorSettings';

export default connect(
  (state: ApplicationState) => ({
    ...Admin.plainActions,
  }),
  Admin.actionCreators,
)(ManageContractorSettings as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
